import { COMPANY_INFO } from '../../constants';

export default function InvoiceLetterhead({ type, saleDocumentTitle }) {
  const title = type === 'sale' ? (saleDocumentTitle || 'Sale Slip') : 'PURCHASE INVOICE';
  return (
    <div className="letterhead">
      <div className="lh-logo">
        <div className="lh-emblem">🎂</div>
        <div>
          <div className="lh-company">{COMPANY_INFO.name}</div>
          <div className="lh-tagline">{COMPANY_INFO.tradingAs} · Birmingham</div>
        </div>
      </div>
      <div className="lh-right">
        <div className="lh-invoice-type">{title}</div>
        <div className="lh-details">
          <strong>{COMPANY_INFO.name}</strong><br />
          {COMPANY_INFO.addressLine}<br />
          {COMPANY_INFO.phone} · {COMPANY_INFO.email}<br />
          Company No. {COMPANY_INFO.companyNo} · VAT No. {COMPANY_INFO.vatNo}
        </div>
      </div>
    </div>
  );
}
